import axios from 'axios'
const AlbumApi = {
    async getSingle(id) {
       const album = await axios.get('/api/album/' + id)
       return album
    }
}

export default AlbumApi